// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProtocolUploadResponse
 */
export interface ProtocolUploadResponse {
    /**
     * 
     * @type {string}
     * @memberof ProtocolUploadResponse
     */
    protocol_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolUploadResponse
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolUploadResponse
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolUploadResponse
     */
    upload_url?: string;
}

/**
 * Check if a given object implements the ProtocolUploadResponse interface.
 */
export function instanceOfProtocolUploadResponse(value: object): value is ProtocolUploadResponse {
    if (!('protocol_id' in value) || value['protocol_id'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    return true;
}

export function ProtocolUploadResponseFromJSON(json: any): ProtocolUploadResponse {
    return ProtocolUploadResponseFromJSONTyped(json, false);
}

export function ProtocolUploadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolUploadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'protocol_id': json['protocol_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'study_id': json['study_id'],
        'upload_url': json['upload_url'] == null ? undefined : json['upload_url'],
    };
}

export function ProtocolUploadResponseToJSON(json: any): ProtocolUploadResponse {
    return ProtocolUploadResponseToJSONTyped(json, false);
}

export function ProtocolUploadResponseToJSONTyped(value?: ProtocolUploadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protocol_id': value['protocol_id'],
        'status': value['status'],
        'study_id': value['study_id'],
        'upload_url': value['upload_url'],
    };
}
